import { createI18n } from 'vue-i18n';
import { messages } from './messages/index.js';
import {
  registerBrandNameListener,
  replaceBrandName
} from '@/stores/theme';

const sourceMessages = JSON.parse(JSON.stringify(messages));

function replaceMessageBrandName(message) {
  if (typeof message === 'string') {
    return replaceBrandName(message);
  }
  if (Array.isArray(message)) {
    return message.map((item) => replaceMessageBrandName(item));
  }
  if (message && typeof message === 'object') {
    return Object.fromEntries(
      Object.entries(message).map(([key, value]) => [key, replaceMessageBrandName(value)])
    );
  }
  return message;
}

const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages,
  postTranslation: replaceBrandName
});

registerBrandNameListener(() => {
  Object.entries(sourceMessages).forEach(([locale, localeMessages]) => {
    i18n.global.setLocaleMessage(locale, replaceMessageBrandName(localeMessages));
  });
});

export default i18n;
